const colorsRGB = {
  info700: "25 116 219",
  primary800: "26 152 131",
  neutral0: "255 255 255",
  neutral50: "218 226 239",
  neutral675: "2 7 50",
} as const;

/**
 * Gets a theme color in rgba.
 *
 * @param name Name of the color
 * @param alpha Alpha value
 * @returns The color as a rgba string
 */
export const color = (name: keyof typeof colorsRGB, alpha = 1) =>
  `rgba(${colorsRGB[name]} / ${alpha})`;

export const font = {
  primary: "SuisseIntl",
} as const;
